import { render } from "./TotalSalesReportGrapics.vue?vue&type=template&id=5c4960b0&scoped=true"
import script from "./TotalSalesReportGrapics.vue?vue&type=script&lang=js"
export * from "./TotalSalesReportGrapics.vue?vue&type=script&lang=js"

import "./TotalSalesReportGrapics.vue?vue&type=style&index=0&id=5c4960b0&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4960b0"]])

export default __exports__